import { call, put, takeLatest } from 'redux-saga/effects';
import { 
  _BROTHER_PLUS_API_ENDPOINTS, 
  ECOPROTOKEN_CLAIMS, 
  LOCALSESSIONDATAKEYS, 
  SUCCESS
} from '../../../../constants/AppConstants';
import { _CALLPOSTAPI } from '../../../../api/apiHandler';
import { getLocalSessionData, getUserDataByKey, getUserSessionData } from '../../../../utils/Authentication/handleUserSession';
import { 
  EnrollmentRegisterServiceFailure, 
  EnrollmentRegisterServiceInit, 
  EnrollmentRegisterServiceSuccess 
} from './RegisterServiceSlice';
import i18next from 'i18next';
import { determineLanguageCodeForPayload, getDeviceInfoForAddNewDevice, getSubscriptionkindBy_SignupType } from '../../../../constants/AppMethod';
import { SOURCE_MY_DEVICE } from '../../../../pages/MyDevices/components/SuppliesComponent';


function _REGISTERSERVICE(enrollmentFor, source, userPlatform){
  const isEcoProUser =  (enrollmentFor && enrollmentFor === 'ECOPRO_USER') ? true : false;
  let deviceID, serialNumber, model;


  const ADB2C_UID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
  const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
  if(source && source === SOURCE_MY_DEVICE){
    deviceID = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.DEVICE_ID);
    serialNumber = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.SERIAL_NUMBER);
    model = getDeviceInfoForAddNewDevice(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
  } else {
    deviceID = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    serialNumber = getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER);
    model = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
  }
  const sapBpID = getUserDataByKey('sapBpId');
  const displayName = getUserDataByKey('displayName', 'personal_details');
  const signupType = getLocalSessionData(LOCALSESSIONDATAKEYS.SIGNUP_TYPE);
  const country = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE);
  const langCode = determineLanguageCodeForPayload();
  const personalOrBusinessAccount = getUserDataByKey('businessModel');
  
  const endpoint = (isEcoProUser)
  ? _BROTHER_PLUS_API_ENDPOINTS.REGISTER_SERVICE_FOR_ECOPRO_USER 
  : _BROTHER_PLUS_API_ENDPOINTS.REGISTER_SERVICE;

  const payload = {
    'userId':UID, 
    'deviceId':deviceID, 
    'sapBpId': sapBpID,
    'personalOrBusiness': personalOrBusinessAccount,
    'serialNumber': serialNumber,
    'model': model,
    'displayName': displayName,
    'subscriptionKind':  getSubscriptionkindBy_SignupType(signupType),
    'userPlatform': userPlatform
  }

    const finalPayload = {
      ...payload,
      ...(isEcoProUser && {
        "adB2CUserId": ADB2C_UID, 
        "countryCode": country, 
        "languageCode" : langCode
      })
    };
   
    return _CALLPOSTAPI(endpoint, finalPayload)
    .then(response => {
      return response;
    })
    .catch((error) => {
        throw error;
    });
}

function* handleRegisterServiceSaga(action) {
  try {
    const { enrollmentFor = null, source = null, userPlatform = 'Web' } = action.payload || {};
    const registerService = yield call(_REGISTERSERVICE, enrollmentFor, source, userPlatform);
    (registerService.actionStatus.toUpperCase() === SUCCESS)
    ? yield put(EnrollmentRegisterServiceSuccess(registerService))
    : yield put(EnrollmentRegisterServiceFailure(i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")));
  } catch (error) {
    yield put(EnrollmentRegisterServiceFailure(error.message));
  }
}

export default function* watchRegisterServiceEcoProUser() {
  yield takeLatest(EnrollmentRegisterServiceInit.type, handleRegisterServiceSaga);
}
